import constants from "../utils/Constants";
import { getData, postData, putData } from "./rest-api-helper";


export async function getNewProdReqListServ({ limit, pageNumber, searchWord, userId, userType, deptId, projIdStrg }) {
    // if (userType === constants.approver) {
    //     const details = {
    //         urlPath: "/newProdReq/byDept",
    //         queryParams: {
    //             ...(searchWord && { searchWord }),
    //             ...(limit && { limit }),
    //             ...(pageNumber && { offset: (pageNumber * limit) - limit }),
    //             ...(deptId && { deptId }),
    //         }
    //     }
    //     const res = await getData(details);
    //     return res.data;
    // }
    // else 
    if (userType === constants.focalPoint || userType === constants.lineManager) {
        const details = {
            urlPath: "/newProdReq/byProj",
            queryParams: {
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(projIdStrg && { projIdStrg }),
            }
        }
        const res = await getData(details);
        return res.data;
    }
    else if (userType === constants.requestor || userType === constants.approver) {
        const details = {
            urlPath: "/newProdReq/byUserDept",
            queryParams: {
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(userId && { userId }),
                ...(deptId && { deptId }),
            }
        }
        const res = await getData(details);
        return res.data;
    }
    else if (userType === constants.sourcing) {
        const details = {
            urlPath: "/source/newProdReqs",
            queryParams: {
                sourceUserId: userId,
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            }
        }
        const res = await getData(details);
        return res.data;
    }
    else if (userType === constants.admin || userType === constants.ma) {
        const details = {
            urlPath: "/newProdReq/byAdmin",
            queryParams: {
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            }
        }
        const res = await getData(details);
        return res.data;
    }
}


export async function createNewProdReqServ(data) {
    const details = {
        urlPath: "/newProdReq",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function getSingleNewProdReqServ(newProdReqIdStrg) {
    const details = {
        urlPath: `/newProdReq/single/${newProdReqIdStrg}`
    }
    const res = await getData(details);
    return res.data;
}

export async function editNewProdReqServ(data, newProdReqIdStrg) {
    const details = {
        urlPath: `/newProdReq/edit/${newProdReqIdStrg}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function updateNewProdReqStatusServ(data, newProdReqIdStrg) {
    const details = {
        urlPath: `/newProdReq/updateStatus/${newProdReqIdStrg}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function sendMailNewProdReqServ(data) {
    const details = {
        urlPath: "/newProdReq/sendMail",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}